import { type Branch } from "@/features/church/config/branches/types/branch.types"

export function generateBranchId() {
  if (typeof crypto !== "undefined" && typeof crypto.randomUUID === "function") {
    return crypto.randomUUID()
  }
  return `branch_${Math.random().toString(36).slice(2, 10)}`
}

export function generateServiceId() {
  if (typeof crypto !== "undefined" && typeof crypto.randomUUID === "function") {
    return crypto.randomUUID()
  }
  return `service_${Math.random().toString(36).slice(2, 10)}`
}

export function createSlug(value: string) {
  const normalized = value
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "")
    .toLowerCase()
    .trim()
    .replace(/[^a-z0-9]+/g, "-")
    .replace(/(^-|-$)/g, "")

  return normalized || "branch"
}

function normalizeName(name: string) {
  return name.trim().toLowerCase()
}

export function hasDuplicateName(branches: Branch[], name: string, ignoreId?: string) {
  const normalized = normalizeName(name)
  return branches.some(
    (branch) => branch.id !== ignoreId && normalizeName(branch.name) === normalized
  )
}
